import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument, sitePullQueryBuilder } from './queryBuilder';

export function sitesFamilyMember(configBuilder: ConfigBuilder): FamilyMember<SiteDocument> {
  const syncConfig = configBuilder<SiteDocument>(RxdbCollectionNameV2.SITES);
  doNotAutoSync(syncConfig);

  pull(syncConfig, sitePullQueryBuilder);
  // The legacy configuration pulled Sites every 15 minutes.
  // This would block synchronization for all family members,
  // so we now just go with the default.

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.SITES, replicationState);
}
